import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import BudgetTypeCreate from '@app/views/BudgetType/Create';
import { memo } from 'react';

export default memo(
  withIfUser(BudgetTypeCreate)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
